module.exports = __webpack_public_path__ + "img/K线图.c01c05ec.png";